import { followingNode } from '../domop';
import { NodeTextNavigation } from './NodeTextNavigation';

export function getTextLengthByNode(node: Node) {
    return new NodeTextNavigation(node).countForwards(followingNode(node));
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/getTextLengthByNode.tsx